import React from "react";
import "./style.css"
const NotFound = () => {
  return (
    <div className="NotFound">
      <img src="https://media.istockphoto.com/vectors/flat-cartoon-character-vector-id1156845283?k=20&m=1156845283&s=612x612&w=0&h=HHtAcCp3sHXHgkqcVo-rMcbYGH36HQkFRSHrKoRBd1c=" />
    </div>
  );
};

export default NotFound